import { render } from "./CardOuvidoria.vue?vue&type=template&id=ae1d9f3e"
import script from "./CardOuvidoria.vue?vue&type=script&lang=js"
export * from "./CardOuvidoria.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__